import { render, staticRenderFns } from "./askQuestion.vue?vue&type=template&id=136c5c4d&scoped=true&"
import script from "./askQuestion.vue?vue&type=script&lang=ts&"
export * from "./askQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c5c4d",
  null
  
)

export default component.exports